import { DEFAULT_SEARCH_LIST_ITEM_SECONDARY_TEXT_KEY } from "constant"
import _ from "lodash"

type PrepareSearchResultSecondaryText = (
  categoryText?: string,
  boothNameText?: string,
  floorText?: string,
  groupText?: string,
  zoneText?: string,
  locationDescriptionText?: string,
  secondaryTextKeyArray?: string[],
  locations?: object[],
  venueName?: string
) => string

export const prepareSearchResultSecondaryText: PrepareSearchResultSecondaryText =
  (
    categoryText,
    boothNameText,
    floorText,
    groupText,
    zoneText,
    locationDescriptionText,
    secondaryTextKeys = DEFAULT_SEARCH_LIST_ITEM_SECONDARY_TEXT_KEY,
    venueName
  ) => {
    const secondaryData = {
      categoryText,
      boothNameText,
      floorText,
      groupText,
      locationDescriptionText,
      venueName,
    }
    const pickedSecondaryDataValues = secondaryTextKeys.map((key) =>
      _.get(secondaryData, key)
    )
    const compactedSecondaryValue = _.compact(pickedSecondaryDataValues).join(
      " - "
    )
    const secondaryText = _.compact([compactedSecondaryValue, zoneText]).join(
      " | "
    )

    return secondaryText || " "
  }
